import ReplyIcon from '@mui/icons-material/Reply';
import React, { useEffect, useMemo, useState } from "react";
// import { Box, CircularProgress, FormControl,Grid,MenuItem,TextField,TableContainer,Paper,Typography,Button} from "@material-ui/core";
import { Autocomplete } from "@mui/material";
import jsPDF from "jspdf";
import "jspdf-autotable";
import axios from "../../../utils/axios";
import PageTitle from "../../../components/PageTitle/PageTitle";
import styles from "../../../reports/ClaimReport/Table.module.css";
import {
  Box, CircularProgress, FormControl, Grid, MenuItem, TextField,
  TableContainer, Paper, Typography, Button, Modal, Table, TableHead,
  TableBody, TableRow, TableCell
} from "@material-ui/core";
const IssuerWiseDividendOutstandingReport = () => {
  const [issuer, setIssuer] = useState("All");
  const [dividendType, setDividendType] = useState("All");
  const [tableData, setTableData] = useState([]);
  const [issuerList, setIssuerList] = useState([
    { id: "All", displayName: "All (All Companies)" },
  ]);
  const [loadingIssuers, setLoadingIssuers] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [error, setError] = useState(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [modalIssuerName, setModalIssuerName] = useState("");
  const [modalDividendType, setModalDividendType] = useState("");
 const [modalStatus, setModatStatus] = useState("");

  const [loading, setLoading] = useState(false);

  //const [tableData, setTableData] = useState([]);


  // Fetch Issuer List
  useEffect(() => {
    const fetchIssuerNames = async () => {
      setLoadingIssuers(true);
      try {
        const { data } = await axios.get("/issuer/get-info");
        if (data?.payload) {
          const formattedIssuerList = data.payload.map((issuer) => ({
            id: issuer.id,
            displayName: `${issuer.name} (${issuer.tradecode})`,
          }));
          setIssuerList([
            { id: "All", displayName: "All (All Companies)" },
            ...formattedIssuerList,
          ]);
        }
      } catch (error) {
        console.error("Error fetching issuer names:", error);
      } finally {
        setLoadingIssuers(false);
      }
    };

    fetchIssuerNames();
  }, []);
  const selectedIssuer = issuerList.find((iss) => iss.id === issuer);

  const issuerName = selectedIssuer
    ? selectedIssuer.displayName
    : "Unknown Issuer";

  // Fetch Table Data
  useEffect(() => {
    const fetchTableData = async () => {
      setLoadingTable(true);
      setError(null);
      try {
        const payload = {
          issuerid: issuer === "All" ? "All" : issuer,
          dividendType: dividendType,
        };

        const response = await axios.post(
          "/investor-informations/get-issuer-wise-bal-manual-report",
          payload,
        );
        if (response.data?.payload?.result) {
          setTableData(response.data.payload.result);
        } else {
          setTableData([]);
        }
      } catch (error) {
        console.error("Error fetching table data:", error);
        setError("Failed to load data. Please try again.");
      } finally {
        setLoadingTable(false);
      }
    };

    fetchTableData();
  }, [issuer, dividendType]);

  // Format API Data for Table
  const formatTableData = (data) => {
    const groupedData = {};
    const formatNumber = (num) =>
      num !== null && !isNaN(num) ? parseFloat(num).toFixed(2) : "-";

    data.forEach((item) => {
      const {
        issuername,
        dividendtypes,
        received,
        define,
        undefine,
        settlement,
        outstanding,
      } = item;

      if (!groupedData[issuername]) {
        groupedData[issuername] = {
          issuername,
          cash: {
            received: "-",
            define: "-",
            undefine: "-",
            settlement: "-",
            outstanding: "-",
          },
          stock: {
            received: "-",
            define: "-",
            undefine: "-",
            settlement: "-",
            outstanding: "-",
          },
        };
      }

      groupedData[issuername][dividendtypes.toLowerCase()] = {
        received: formatNumber(received),
        define: formatNumber(define),
        undefine: formatNumber(undefine),
        settlement: formatNumber(settlement),
        outstanding: formatNumber(outstanding),
      };
    });

    return Object.values(groupedData);
  };
  const formatNumber = (num) =>
    num !== null && !isNaN(num) ? parseFloat(num).toFixed(2) : "-";

  // Use Memoized Formatted Data
  const formattedData = useMemo(() => formatTableData(tableData), [tableData]);


  const totals = {
    cash: {
      received: 0,
      define: 0,
      undefine: 0,
      settlement: 0,
      outstanding: 0,
    },
    stock: {
      received: 0,
      define: 0,
      undefine: 0,
      settlement: 0,
      outstanding: 0,
    },
  };

  formattedData.forEach((row) => {
    totals.cash.received += parseFloat(row.cash?.received) || 0;
    totals.cash.define += parseFloat(row.cash?.define) || 0;
    totals.cash.undefine += parseFloat(row.cash?.undefine) || 0;
    totals.cash.settlement += parseFloat(row.cash?.settlement) || 0;
    totals.cash.outstanding += parseFloat(row.cash?.outstanding) || 0;

    totals.stock.received += parseFloat(row.stock?.received) || 0;
    totals.stock.define += parseFloat(row.stock?.define) || 0;
    totals.stock.undefine += parseFloat(row.stock?.undefine) || 0;
    totals.stock.settlement += parseFloat(row.stock?.settlement) || 0;
    totals.stock.outstanding += parseFloat(row.stock?.outstanding) || 0;
  });


  


  const handleCellClick = async (issuerName, dividendType, status, value) => {
 
    // Find issuer object by name match (you can make this stricter if needed)
    const issuerObj = issuerList.find(item =>
      item.displayName.toLowerCase().includes(issuerName.toLowerCase())
    );
  console.log(issuerName)
    if (!issuerObj) {
      console.error("Issuer not found");
      return; // Avoid making the API request if the issuer is not found
    }
  
    const payload = {
      value: value,
      issuerId: issuerObj.id,
      dividendType,
      status,
    };
  
    console.log("Sending payload:", payload);
  
     try {
    
      const response = await axios.post("/investor-informations/get-issuer-wise-outstanding", payload);
      if (response.data?.success && response.data.payload?.result) {
        setModalData(response.data.payload.result);
     
          setModalIssuerName(issuerName);
          setModalDividendType(dividendType);
          setModatStatus (status);
          setModalOpen(true);
        
      }
    } catch (error) {
      console.error("API error:", error);
    }
    finally{
       setLoading(false);
    }
  };
  




  const renderClickableCell = (value, issuerName, dividendType, status) => {
    // Make "Outstanding" cells non-clickable
    const isClickable = status !== "Outstanding";
  
  
    return (
      <td
        className={styles.td}
        colSpan={3}
        onClick={isClickable ? () => handleCellClick(issuerName, dividendType, status, value) : undefined}
        style={{
          cursor: isClickable ? "pointer" : "default",
          color: isClickable ? "#242d7c" : "black"
        }}
      >
        {value}
      </td>
    );
  };
  
  

  return (
    <>
      <PageTitle title="Issuer Wise Dividend Outstanding Report" />

      {/* Dropdown Filters */}
      <Grid container spacing={2} style={{ marginBottom: "20px" }}>
        {/* Issuer Dropdown */}
        <Grid item xs={6}>
          <FormControl fullWidth>
            <Autocomplete
              options={issuerList}
              getOptionLabel={(option) => option.displayName}
              value={issuerList.find((item) => item.id === issuer) || null}
              onChange={(_, newValue) =>
                setIssuer(newValue ? newValue.id : "All")
              }
              loading={loadingIssuers}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Issuer Name"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loadingIssuers ? <CircularProgress size={24} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </FormControl>
        </Grid>

        {/* Dividend Type Dropdown */}
        <Grid item xs={6}>
          <FormControl fullWidth>
            <TextField
              select
              label="Dividend Type"
              value={dividendType}
              onChange={(e) => setDividendType(e.target.value)}
              variant="outlined"
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Cash">Cash</MenuItem>
              <MenuItem value="Stock">Stock</MenuItem>
            </TextField>
          </FormControl>
        </Grid>
      </Grid>

      <div style={{ backgroundColor: "white" }}>
        {/* Table Data */}
        <Typography
          variant="h5"
          style={{
            fontWeight: "bold",
            marginBottom: "10px",
            textAlign: "center",
          }}
        >
          Issuer Wise Dividend Outstanding Report
        </Typography>

        {loadingTable ? (
          <Box display="flex" justifyContent="center">
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box textAlign="center" color="red">
            {error}
          </Box>
        ) : (
          <TableContainer
          component={Paper}
          style={{
            maxHeight: "400px",
            overflowY: "auto",
            
          }}
        >
          <table className={styles.fixedTable}>
            <thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "white",
                zIndex: 2,
              }}
            >
              <tr>
                <th className={styles.td} colSpan={6}></th>
                {dividendType !== "Stock" && (
                  <th className={styles.td} colSpan={15} style={{ textAlign: "center" }}>
                    Cash
                  </th>
                )}
                {dividendType !== "Cash" && (
                  <th className={styles.td} colSpan={15} style={{ textAlign: "center" }}>
                    Stock
                  </th>
                )}
              </tr>
              <tr>
                <th className={styles.td} colSpan={3}>Sl</th>
                <th className={styles.td} colSpan={3}>Issuer Name</th>
                {dividendType !== "Stock" && (
                  <>
                    <th className={styles.td} colSpan={3}>Received</th>
                    <th className={styles.td} colSpan={3}>Define</th>
                    <th className={styles.td} colSpan={3}>Undefine</th>
                    <th className={styles.td} colSpan={3}>Settlement</th>
                    <th className={styles.td} colSpan={3}>Outstanding</th>
                  </>
                )}
                {dividendType !== "Cash" && (
                  <>
                    <th className={styles.td} colSpan={3}>Received</th>
                    <th className={styles.td} colSpan={3}>Define</th>
                    <th className={styles.td} colSpan={3}>Undefine</th>
                    <th className={styles.td} colSpan={3}>Settlement</th>
                    <th className={styles.td} colSpan={3}>Outstanding</th>
                  </>
                )}
              </tr>
            </thead>
    
            <tbody>
              {formattedData.map((row, index) => (
                <tr key={index}>
                  <td className={styles.td} colSpan={3}>{index + 1}</td>
                  <td className={styles.td} colSpan={3}>{row.issuername}</td>
    
                  {dividendType !== "Stock" && (
                    <>
                      {renderClickableCell(row.cash.received, row.issuername, "Cash", "Received")}
                      {renderClickableCell(row.cash.define, row.issuername, "Cash", "Define")}
                      {renderClickableCell(row.cash.undefine, row.issuername, "Cash", "Undefine")}
                      {renderClickableCell(row.cash.settlement, row.issuername, "Cash", "Settlement")}
                      {renderClickableCell(row.cash.outstanding, row.issuername, "Cash", "Outstanding")}
                    </>
                  )}
    
                  {dividendType !== "Cash" && (
                    <>
                      {renderClickableCell(row.stock.received, row.issuername, "Stock", "Received")}
                      {renderClickableCell(row.stock.define, row.issuername, "Stock", "Define")}
                      {renderClickableCell(row.stock.undefine, row.issuername, "Stock", "Undefine")}
                      {renderClickableCell(row.stock.settlement, row.issuername, "Stock", "Settlement")}
                      {renderClickableCell(row.stock.outstanding, row.issuername, "Stock", "Outstanding")}
                    </>
                  )}
                </tr>
              ))}
            </tbody>
    
            <tfoot
              style={{
                position: "sticky",
                bottom: 0,
                backgroundColor: "white",
                zIndex: 2,
              }}
            >
              <tr style={{ fontWeight: "bold", backgroundColor: "white" }}>
                <td className={styles.td} colSpan={3}>Total</td>
                <td className={styles.td} colSpan={3}></td>
    
                {dividendType !== "Stock" && (
                  <>
                    <td className={styles.td} colSpan={3}>{totals.cash.received.toFixed(2)}</td>
                    <td className={styles.td} colSpan={3}>{totals.cash.define.toFixed(2)}</td>
                    <td className={styles.td} colSpan={3}>{totals.cash.undefine.toFixed(2)}</td>
                    <td className={styles.td} colSpan={3}>{totals.cash.settlement.toFixed(2)}</td>
                    <td className={styles.td} colSpan={3}>{totals.cash.outstanding.toFixed(2)}</td>
                  </>
                )}
    
                {dividendType !== "Cash" && (
                  <>
                    <td className={styles.td} colSpan={3}>{totals.stock.received.toFixed(2)}</td>
                    <td className={styles.td} colSpan={3}>{totals.stock.define.toFixed(2)}</td>
                    <td className={styles.td} colSpan={3}>{totals.stock.undefine.toFixed(2)}</td>
                    <td className={styles.td} colSpan={3}>{totals.stock.settlement.toFixed(2)}</td>
                    <td className={styles.td} colSpan={3}>{totals.stock.outstanding.toFixed(2)}</td>
                  </>
                )}
              </tr>
            </tfoot>
          </table>
        </TableContainer>
        )}
      </div>







<Modal open={modalOpen} onClose={() => setModalOpen(false)}>
  <Box
    style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "white",
      padding: "8px",
      maxHeight: "80vh",
      width: "80%",
      borderRadius: "8px",
      display: "flex",
      flexDirection: "column",
       minHeight: "200px", // optional for spacing
    }}
  >

 
   <Typography
          variant="h4"
          style={{
            fontWeight: "bold",
            marginBottom: "10px",
            textAlign: "center",
          }}
        >
       Detailed Dividend Information for {modalIssuerName} 
        </Typography>

<div>
  <h5 style={{ fontWeight: "bold" }}>
  Dividend Type: {modalDividendType}

  </h5>
    <h5 style={{ fontWeight: "bold" }}>

  Dividend Status : {modalStatus}
  </h5>
  
 </div>


    {/* Scrollable Content */}
    <Box style={{ overflowY: "auto", flex: 1, marginBottom: "1px" }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell style={{ fontWeight: "bold" }}>BO ID</TableCell>
            <TableCell>Folio No</TableCell>
            <TableCell>Full Name</TableCell>
            <TableCell>Dividend Year</TableCell>
            <TableCell>Dividend Type</TableCell>
            <TableCell>No. of Share</TableCell>
            <TableCell>Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {modalData.map((row, idx) => (
            <TableRow key={idx}>
                 <TableCell>{row.boid}</TableCell>
              <TableCell>{row.foliono}</TableCell>
              <TableCell>{row.fullname}</TableCell>
              <TableCell>{row.dividendyear}</TableCell>
              <TableCell>{row.dividendtype}</TableCell>
              <TableCell>{row.noofshare}</TableCell>
              <TableCell>{row.amount}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>

    {/* Fixed Back Button */}
    <Box display="flex" justifyContent="center">
      <Button variant="contained" color="primary"onClick={() => setModalOpen(false)}>
        <ReplyIcon/> Go Back
      </Button>
    </Box>
  </Box>
</Modal>



   
    </>
  );
};
export default IssuerWiseDividendOutstandingReport;
